import React, { PureComponent } from 'react';
import { SidebarContext, SidebarItemContext } from '../SidebarAPI';
export class SidebarItem extends PureComponent {
    constructor() {
        super(...arguments);
        this.displayName = 'SidebarItem';
    }
    render() {
        const { dataHook } = this.props;
        return (React.createElement(SidebarContext.Consumer, null, context => (React.createElement("div", { "data-hook": dataHook, onClick: e => {
                if (!this.props.disable) {
                    if (this.props.onClick) {
                        this.props.onClick(this.props.itemKey, e);
                    }
                    if (!e.defaultPrevented) {
                        context.itemClicked(this.props.itemKey);
                    }
                }
            } },
            React.createElement(SidebarItemContext.Provider, { value: {
                    selected: () => context.getSelectedKey() === this.props.itemKey,
                    getIsMenuExpanded: () => context.getIsMenuExpanded(),
                } }, this.props.children)))));
    }
}
//# sourceMappingURL=SidebarItem.js.map